import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserPublicApiCredentialsFragment = { id: string, name: string, createdAt: string };


export type UserPublicApiCredentialsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type UserPublicApiCredentialsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UserPublicApiCredentialsFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type UserPublicApiCredentialsQuery = { userPublicAPICredentials: { edges?: Array<{ node: { id: string, name: string, createdAt: string } }> | null } };

export const UserPublicApiCredentialsFragmentDoc = /*#__PURE__*/ gql`
    fragment UserPublicAPICredentials on UserPublicAPICredentialsType {
  id
  name
  createdAt
}
    `;
export const UserPublicApiCredentialsDocument = /*#__PURE__*/ gql`
    query userPublicAPICredentials($filters: UserPublicAPICredentialsFilters, $first: Float, $after: String, $sort: [SortType!]) {
  userPublicAPICredentials(
    sort: $sort
    filters: $filters
    first: $first
    after: $after
  ) {
    edges {
      node {
        ...UserPublicAPICredentials
      }
    }
  }
}
    ${UserPublicApiCredentialsFragmentDoc}`;

export function useUserPublicApiCredentialsQuery(options?: Omit<Urql.UseQueryArgs<UserPublicApiCredentialsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserPublicApiCredentialsQuery, UserPublicApiCredentialsQueryVariables>({ query: UserPublicApiCredentialsDocument, ...options });
};